export const getHome = state => state.homeContent.data;
export const getInstagramData = state => state.homeContent.instagramData;
export const getRecommendedProductsData = state => state.homeContent.recommendedProducts;
export const getError = state => state.homeContent.error;
export const getBanner = state => state.homeContent.banner;
export const getBanners = state => state.homeContent.banners;
export const getBannerError = state => state.homeContent.error;
export const getLoading = state => state.homeContent.isLoading;
